<div class="w-1/2">
  <h2 mat-dialog-title>Notification</h2>
  <div mat-dialog-content>
    <p>Données enregistrées</p>
  </div>
</div>
